import { FollowUpBadge } from "./LeadDetail";
import { StatusBadge } from "./leadUtils";

const headers = ["Data", "Stato", "Richiamo", "Nome", "Brand", "Email", "WhatsApp", "Paese", "Nota", ""];

export const LeadTable = ({ leads, onOpen }) => (
  <div className="overflow-x-auto border hairline">
    <table className="w-full text-left" data-testid="admin-leads-table">
      <thead>
        <tr className="border-b hairline bg-linen font-sans-ui text-[10px] tracking-mega text-ink/50">
          {headers.map((h) => (
            <th key={h || "actions"} className="px-4 py-3 font-medium whitespace-nowrap">{h}</th>
          ))}
        </tr>
      </thead>
      <tbody className="font-sans-ui text-[13px]">
        {leads.map((l) => (
          <tr key={l.id} data-testid={`lead-row-${l.id}`} className="border-b hairline hover:bg-linen/50 transition-colors cursor-pointer" onClick={() => onOpen(l)}>
            <td className="px-4 py-3 whitespace-nowrap text-ink/60">{(l.created_at || "").slice(0, 16).replace("T", " ")}</td>
            <td className="px-4 py-3 whitespace-nowrap"><StatusBadge status={l.status} /></td>
            <td className="px-4 py-3 whitespace-nowrap"><FollowUpBadge lead={l} /></td>
            <td className="px-4 py-3 whitespace-nowrap">{l.full_name}</td>
            <td className="px-4 py-3 whitespace-nowrap">{l.brand_name}</td>
            <td className="px-4 py-3 whitespace-nowrap text-ink/70">{l.email}</td>
            <td className="px-4 py-3 whitespace-nowrap text-ink/70">{l.whatsapp}</td>
            <td className="px-4 py-3 whitespace-nowrap">{l.country}</td>
            <td className="px-4 py-3 text-ink/55 max-w-[220px] truncate">{l.notes || "—"}</td>
            <td className="px-4 py-3"><span className="text-[10px] tracking-mega text-ink/50 underline underline-offset-2">DETTAGLI</span></td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
